import React from 'react';

// Brillo que sigue al cursor (efecto spotlight estilo Framer/Linear)
const handleMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty('--x', `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty('--y', `${e.clientY - r.top}px`);
};

// Tarjeta de servicio de marca (fondo claro) alineada al lenguaje visual del inicio:
// barra de acento lateral, número tenue, ícono circular azul con anillo verde,
// eyebrow verde opcional, título Montserrat con subrayado y spotlight verde al hover.
const ServiceCard = ({ index, icon, subtitle, title, text, items, delay = 0, titleClass = 'text-xl' }) => (
    <div
        onMouseMove={handleMove}
        className="group relative overflow-hidden rounded-2xl bg-white border border-slate-200/80 shadow-sm p-8 pl-9 flex flex-col transition-all duration-300 ease-out hover:-translate-y-2 hover:shadow-2xl hover:border-salient-green/50 will-change-transform"
        data-aos="fade-up"
        data-aos-delay={delay}
    >
        {/* Barra de acento lateral (firma de marca) */}
        <span className="absolute left-0 top-0 h-full w-1.5 bg-gradient-to-b from-salient-green to-salient-primary"></span>

        {/* Número grande tenue (igual que en el inicio) */}
        {typeof index === 'number' && (
            <span className="font-heading absolute top-5 right-6 font-bold text-6xl leading-none select-none text-salient-primary/[0.06]">
                {String(index + 1).padStart(2, '0')}
            </span>
        )}

        {/* Brillo que sigue al cursor (spotlight verde) */}
        <div
            className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
            style={{ background: 'radial-gradient(380px circle at var(--x) var(--y), rgba(153,225,122,0.18), transparent 60%)' }}
        ></div>

        <div className="relative z-10 flex flex-col h-full">
            {/* Ícono en círculo azul con anillo verde */}
            <div className="w-16 h-16 mb-6 flex items-center justify-center rounded-full bg-gradient-to-br from-salient-primary to-salient-primary-hover text-white text-2xl ring-4 ring-salient-green/15 border border-salient-green/30 transition-transform duration-300 ease-out group-hover:scale-110 group-hover:-rotate-3">
                <i className={`fas ${icon}`}></i>
            </div>

            {subtitle && (
                <p className="text-salient-green font-bold text-xs uppercase tracking-[0.15em] mb-2">{subtitle}</p>
            )}
            <h3 className={`font-heading ${titleClass} font-bold text-salient-primary mb-3`}>{title}</h3>
            <span className="block w-10 h-1 rounded-full bg-salient-green mb-4"></span>

            {text && <p className="text-slate-600 leading-relaxed">{text}</p>}

            {items && (
                <ul className="space-y-3 mt-1">
                    {items.map((it, i) => (
                        <li key={i} className="flex items-start text-slate-600">
                            <i className="fas fa-check mt-1 mr-3 text-salient-green"></i>
                            <span>{it}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    </div>
);

export default ServiceCard;
